import isEmpty from 'lodash/isEmpty';
import { GetStaticProps, NextPage } from 'next';
import React from 'react';

import HeadMeta from '@/components/static-pages/HeadMeta';
import RoadsideAssitanceTemplate from '@/components/templates/RoadsideAssistanceTemplate';
import { getStaticPageData } from '@/services/getPageData';

export enum ELeftSplitType {
  image = 'image',
  heading = 'heading',
  richText = 'richtext',
}

export enum ERightSplitType {
  richText = 'richtext',
}
export interface ISplitContentBlock {
  left: {
    type: ELeftSplitType;
    value: string & {
      title: string;
      url: string;
    };
  }[];
  right: {
    type: ERightSplitType;
    value: string;
  }[];
}
export interface IRoadsideAssistanceProps {
  seoTitle: string;
  seoDescription: string;
  heading: string;
  subheading: string;
  heroImage: string;
  contentBlocks: { type: string; value: ISplitContentBlock }[];
  noindex: boolean;
}

const RoadsideAssistance: NextPage<IRoadsideAssistanceProps> = props => {
  return (
    <>
      <HeadMeta title={props.seoTitle} description={props.seoDescription} noindex={props.noindex} />
      <RoadsideAssitanceTemplate {...props} />
    </>
  );
};

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const pageData = await getStaticPageData({ locale, url_path: 'roadside-assistance' });
  if (isEmpty(pageData) || isEmpty(pageData.metadata)) {
    return {
      notFound: true,
      revalidate: true,
    };
  }

  const { seo_title, seo_description, heading, subheading, hero_image, content_blocks } =
    pageData.metadata;

  return {
    props: {
      seoTitle: seo_title,
      seoDescription: seo_description,
      heading,
      subheading,
      heroImage: hero_image,
      contentBlocks: content_blocks,
      noindex: !!pageData.fallback,
    },
  };
};

export default RoadsideAssistance;
